export enum NextStep {
  CheckIn = 'CheckIn',
  RejoinWaitingRoom = 'RejoinWaitingRoom',
  SigningRoom = 'SigningRoom',
  WaitingRoom = 'WaitingRoom',
}
